import API from '@/services/http'
import * as Types from './type'
import type { PickUpTimeType, ResponseProviderInfo, ExpressListState, ExpressListPayload } from '@/store/serviceProviderSlice/types'

export const queryPickUpTime = (payload: PickUpTimeType) => {
  return API.admin.post<ResponseProviderInfo>('/api/express/pick_up_time', payload)
}

/**
 * 获取服务产品列表
 * @param payload
 * @returns
 */
export const getExpressList = (payload: ExpressListPayload) => {
  return API.admin.post<ExpressListState>('/api/express/list', payload)
}

/**
 * 服务产品配置
 * @param payload
 * @returns
 */
export const queryExpressConfig = (payload: Types.ExpressTypeConfigListRequest) => {
  return API.normal.post<Types.ExpressConfigRes>('/api/express/config', payload)
}

/**
 * get guidance express list
 */
export const getGuideExpress = () => {
  return API.admin.post<CompanyExpressListRes>('/api/express/company_express_list')
}

/**
 * get guidance express list
 */
export const changeExpressState = (payload: { companyCode: string; status: string }) => {
  return API.admin.post('/api/express/company_switch', payload)
}

export const saveExpressConfig = (payload: SellerCompanyRequest) => {
  return API.admin.post('/api/express/company_express_config_save', payload)
}

interface SellerCompanyExpressRequest {
  /**服务商编码（约束：expressTypeCode must not be blank） */
  expressTypeCode: string
  /**禁用或启用（disabled-禁用 enable-启用） DISABLED( "disabled","禁用" ),ENABLE( "enable","启用" )（约束：status must not be blank） */
  status: string
}

export interface SellerCompanyRequest {
  /**服务商编码（约束：companyCode must not be blank） */
  companyCode: string
  /**禁用或启用（disabled-禁用 enable-启用） DISABLED( "disabled","禁用" ),ENABLE( "enable","启用" )（约束：status must not be blank） */
  status: string
  /**服务产品启用禁用列表 */
  companyExpressList: SellerCompanyExpressRequest[]
}

export interface OneshipExpressTypeSimpleVo {
  /**服务产品编码, 标准的 */
  expressTypeCode?: string
  /**服务产品名称, 标准的 */
  expressTypeName?: string
  /**承运商编码 */
  companyCode?: string
  /**承运商名称 */
  companyName?: string
  /**承诺送达时间/物流时效 */
  promisedTime?: string
  /**支持的配送地址类型:
STORE_STREET:超商取货
HOME_STREET:宅配
PO_BOX:自取
POST_HOUSE:自取 */
  supportedAddressType?: string[]
  /**服务产品支持的揽收方式：1:PICK_UP 上门揽收;2:DROP_OFF 商家自寄 eg：[1,2] */
  supportedPickupTypes?: number[]
  /**是否需要字账号,1：需要；0：不需要 */
  needSubAccount?: number
  /**oneship授权状态 true 已开通 false 未开通 */
  authStatus?: boolean
  /**结算属性 1-代收货款  2-线上支付
ec2.0新增 */
  supportedCheckoutTypes?: number[]
  /**支持的结算方式：
1=寄付现结
2=到付现结
3=寄付月结
4=到付月结 */
  settlementModes?: number[]
  /**服务产品类型
- 1:标准，2：SAAS */
  channelRelationType?: number
  /**是否支持保险服务 0否1是 */
  insuranceSupport?: number
  /**保险配置 */
  insuranceSetting?: OneshipExpressTypeInsuranceSettingVo
  /**预约派送时间配置 */
  selectableDeliveryList?: OneshipSelectableDeliveryListVo
  /**其他服务
- 比如：是否支持取消 */
  supportedOtherServices?: number[]
  /** 是否saas服务产品：0-否，1-是 */
  saasFlag?: number
  /**支持的签收服务 */
  supportSignServiceTypes?: string[]
  /**禁用或启用（disabled-禁用 enable-启用） DISABLED( "disabled","禁用" ),ENABLE( "enable","启用" ) */
  status?: string
}

export interface ExpressTypeGroupCompanyVo {
  supportedPickupTypes: any
  supportedAddressType: any
  /**服务商编码 */
  companyCode?: string
  /**服务商名称 */
  companyName?: string
  /**服务商服务产品列表 */
  expressTypes?: OneshipExpressTypeSimpleVo[]
  /**禁用或启用（disabled-禁用 enable-启用） DISABLED( "disabled","禁用" ),ENABLE( "enable","启用" ) */
  status?: string

  containOnDemand?: boolean
}

interface NewGuideExpressTypeVo {
  /**已授权服务产品 */
  authExpressTypes?: ExpressTypeGroupCompanyVo[]
  /**未授权服务产品 */
  unAuthExpressTypes?: ExpressTypeGroupCompanyVo[]
}

export interface CompanyExpressListRes {
  /**是否成功 */
  isSuccess?: boolean
  /**扩展属性 */
  extMap?: any
  /**新手教学服务产品 */
  expressTypeVo?: NewGuideExpressTypeVo
}

interface OneshipExpressTypeInsuranceSettingVo {
  /**保费设置模版唯一编码 */
  settingSeq?: string
  /**保费模版设置价值区间最小值
（标准货币单位 * 100） */
  minInsuredAmount?: number
  /**保费模版设置价值区间最大值
（标准货币单位 * 100）
Long.MAX_VALUE表示无限 */
  maxInsuredAmount?: number
  /**币种 */
  currencyCode?: string
}

interface OneshipSelectableDeliveryListVo {
  countryCode?: string
  selectableDeliveryTimes?: OneshipSelectableDeliveryTimeVo[]
}

interface OneshipSelectableDeliveryTimeVo {
  /**日期 */
  date?: string
  /**时间段 */
  timeIntervals?: string[]
}
